class AANMainNav {
	setAriaExpanded(button: HTMLButtonElement, expandValue: boolean) {
		if (button.hasAttribute("aria-expanded")) {
			button.setAttribute("aria-expanded", expandValue.toString());
		}
	}

	toggleMobileMenu (button: HTMLButtonElement) {
		if (button.parentElement?.classList.contains("submenu-open")) {
			button.parentElement.classList.remove("submenu-open");
			button.parentElement.parentElement?.classList.remove("submenu-open");
			this.setAriaExpanded(button, false);
		} else {
			button.parentElement?.classList.add("submenu-open");
			button.parentElement?.parentElement?.classList.add("submenu-open");
			this.setAriaExpanded(button, true);
		}
	};

	toggleMobileSubnav (button: HTMLButtonElement) {
		if (button.parentElement?.classList.contains("submenu-open")) {
			button.parentElement.classList.remove("submenu-open");
			this.setAriaExpanded(button, false);
		} else {
			button.parentElement?.classList.add("submenu-open");
			this.setAriaExpanded(button, true);
		}
	};
}

document.addEventListener("DOMContentLoaded", () => {
	const mainNav = new AANMainNav();
	const mainNavButtons: HTMLButtonElement[] = Array.from(document.querySelectorAll(".main-nav .toggle-nav"));
	const subnavButtons: HTMLButtonElement[] = Array.from(document.querySelectorAll(".main-nav .toggle-subnav"));

	mainNavButtons.forEach(button => {
		button.addEventListener("click", () => {
			mainNav.toggleMobileMenu(button);
		});
	});

	subnavButtons.forEach(subnavButton => {
		subnavButton.addEventListener("click", () => {
			mainNav.toggleMobileSubnav(subnavButton);
		});
	});
});
